// extracted by mini-css-extract-plugin
export default {"readonly":"DateInput_readonly__3s1a7"};